import { Timestamp } from '@britishcouncil/common-core';
import { SemanticCOLORS } from 'semantic-ui-react';

import { CertificationStatus } from 'api';
import { getCertificationStatusName } from 'const/certification-status/certificationStatusHelpers';

const soonExpiredInDays = 30;

export function getStatusText(
  status: CertificationStatus | undefined,
  nextCertificationDate?: string | null
): string {
  if (!status) {
    return '';
  }

  if (
    status === CertificationStatus.Current &&
    nextCertificationDate &&
    isStatusSoonExpire(nextCertificationDate)
  ) {
    const daysToExpire = getDaysToExpire(nextCertificationDate);

    return (
      getCertificationStatusName(status) +
      (daysToExpire < 0 ? ' (certification has expired)' : ` (will expire in ${daysToExpire} days)`)
    );
  }

  return getCertificationStatusName(status);
}

export function getStatusColor(
  status?: CertificationStatus,
  nextCertificationDate?: string | null
): SemanticCOLORS {
  if (!status) {
    return 'grey';
  }

  switch (status) {
    case CertificationStatus.Expired:
    case CertificationStatus.Suspended:
    case CertificationStatus.Withdrawn:
    case CertificationStatus.Inactive:
    case CertificationStatus.Standardising: {
      return 'red';
    }
    case CertificationStatus.New: {
      return 'blue';
    }
    case CertificationStatus.Current: {
      if (isStatusSoonExpire(nextCertificationDate)) {
        return 'yellow';
      }
      return 'green';
    }
    case CertificationStatus.StandardisationDue:
    case CertificationStatus.Restricted: {
      return 'yellow';
    }
    default: {
      return 'grey';
    }
  }
}

function getDaysToExpire(nextCertificationDate: string): number {
  const today = Timestamp.now();
  const nextDate = Timestamp.parse(nextCertificationDate);

  return Timestamp.differenceInCalendarDays(nextDate)(today);
}

function isStatusSoonExpire(nextCertificationDate?: string | null): boolean {
  if (!nextCertificationDate) {
    return false;
  }

  return getDaysToExpire(nextCertificationDate) <= soonExpiredInDays;
}
